import React, { Component } from 'react';
import Cabecalho from '../componentes/Cabecalho';
import Rodape from '../componentes/Rodape';
import { firestore } from './../firebase-config';
import { Link } from 'react-router-dom';
import { ValidatorForm, TextValidator, SelectValidator } from 'react-material-ui-form-validator';
import MenuItem from "@material-ui/core/MenuItem";
import { id_firebase, ids_firebase, href_revenda } from '../content-site';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import './Inicio.css';


class Estoque extends Component {
    constructor(props) {
        super(props);

        this.state = {
            veiculos: [],
            veiculosComplete: [],
            countVeiculos: 0,
            instagramData: [],
            buscaVeiculo: '',
            tipoVeiculo: 'todos',
            revenda: {},
            revendaPissarelli: {},
            bannerData: [],
            currentPage: 1,
            vehiclesPerPage: 30
        }
        this.mounted = false;

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        this.mounted = true;

        firestore.collection("revenda").doc(id_firebase)
            .get()
            .then(doc => {
                if (doc.exists) {
                    this.setState({
                        revenda: doc.data(),
                    });
                } else {
                    this.setState({
                        revenda: {
                            ativo: 0,
                        }
                    });
                }
            }).catch(function (error) {
            });

        const allVehicles = [];
        let completedQueries = 0;


        ids_firebase.forEach((id, index) => {
            const revendaDocRef = firestore.collection("revenda").doc(id);

            revendaDocRef.collection("veiculos")
                .where("veremovido", "==", 0)
                .where("vevendido", "==", 0)
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        var vehicle = doc.data();
                        vehicle.id = doc.id;
                        vehicle.href_revenda = href_revenda[index]; // Adiciona a propriedade href_revenda
                        if (vehicle["veexibir_site"] !== false) {
                            allVehicles.push(vehicle);
                        }

                    });

                    completedQueries++;

                    if (this.mounted && completedQueries === ids_firebase.length) {
                        const veiculosEmbaralhados = shuffleArray(allVehicles);

                        this.setState({
                            veiculos: veiculosEmbaralhados,
                            veiculosComplete: veiculosEmbaralhados
                        });
                    }
                    //XML()
                })
                .catch(error => {
                    console.error("Error getting documents: ", error);
                });


            revendaDocRef.collection("imagem_destaque").orderBy("created_at", "desc")
                .onSnapshot(querySnapshot => {
                    var items = [];
                    querySnapshot.forEach(doc => {
                        var document = doc.data();
                        document.id = doc.id;
                        items.push(document);
                    });
                    if (this.mounted) {
                        this.setState(prevState => ({
                            instagramData: [...prevState.instagramData, ...items]
                        }));
                    }
                });

            revendaDocRef.collection("banner_site").orderBy("created_at", "desc")
                .onSnapshot(querySnapshot => {
                    var items = [];
                    querySnapshot.forEach(doc => {
                        var document = doc.data();
                        document.id = doc.id;
                        if (document.imagem_url !== undefined && document.imagem_url.trim().length > 0) {
                            items.push(document.imagem_url);
                        }
                    });
                    if (this.mounted) {
                        this.setState(prevState => ({
                            bannerData: [...prevState.bannerData, ...items]
                        }));
                    }
                });
        });
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {
        let filtro = this.state.buscaVeiculo.toLowerCase();
        let tipoVeiculo = this.state.tipoVeiculo;

        let veiculosFilter = this.state.veiculosComplete.filter(function (veiculo) {
            let descricaoVeiculo = veiculo.vefipe_marca.toLowerCase() + " " + veiculo.vefipe_name.toLowerCase();
            if (tipoVeiculo === 'novos') {
                return descricaoVeiculo.includes(filtro) && veiculo.vequilometragem <= 100;
            }
            if (tipoVeiculo === 'seminovos') {
                return descricaoVeiculo.includes(filtro) && veiculo.vequilometragem > 100;
            }
            return descricaoVeiculo.includes(filtro);
        });

        this.setState({
            veiculos: shuffleArray(veiculosFilter),
            currentPage: 1
        });

    }

    handleClick(event) {
        this.setState({
            veiculos: shuffleArray(this.state.veiculosComplete),
            buscaVeiculo: '',
            tipoVeiculo: 'todos',
            currentPage: 1
        });
    }

    handlePageChange = (pageNumber) => {
        this.setState({ currentPage: pageNumber });
    }

    renderPageNumbers = () => {
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.state.veiculos.length / this.state.vehiclesPerPage); i++) {
            pageNumbers.push(i);
        }
        return pageNumbers.map(number => (
            <li 
                key={number} 
                className={this.state.currentPage === number ? "active" : ""}
                onClick={() => this.handlePageChange(number)}
            >
                <a href="#!" onClick={(event) => event.preventDefault()}>{number}</a>
            </li>
        ));
    }
    

    render() {
        const {
            veiculos,
            tipoVeiculo,
        } = this.state;

        if (this.state.revenda.ativo === 0) {
            return (
                <div style={{ textAlign: "center" }}>
                    <h1>Site em manutenção.</h1>
                    <h3>Contate o suporte para mais detalhes (suporte@intermedioveiculos.com.br)</h3>
                </div>
            )
        }

        const indexOfLastVehicle = this.state.currentPage * this.state.vehiclesPerPage;
        const indexOfFirstVehicle = indexOfLastVehicle - this.state.vehiclesPerPage;
        const currentVehicles = this.state.veiculos.slice(indexOfFirstVehicle, indexOfLastVehicle);



        return (
            <div>
                <Cabecalho revenda={this.state.revenda} />

                <section className="product-listing page-section-ptb" style={{ paddingTop: "10px" }}>
                    <section class="hero">
                    <div class="hero-bg"></div>
                    <div class="hero-content">
                        <span class="hero-label">Multimarcas</span>
                        <h1 class="hero-title">
                            ESTOQUE
                        </h1>
                        <p class="hero-sub">
                           {veiculos.length} VEÍCULOS DISPONÍVEIS
                        </p>
                    </div>
                </section >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-8">
                                <ValidatorForm id="contactForm" className="s-form wow zoomInUp" ref="form" onSubmit={this.handleSubmit} >
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="col-lg-6">
                                                <TextValidator placeholder="Ex.: Fiat Palio"
                                                    label="Encontre seu veículo"
                                                    onChange={this.handleChange}
                                                    name="buscaVeiculo"
                                                    value={this.state.buscaVeiculo}
                                                    className="form-ui-bootstrap" />

                                            </div>

                                            <div className="col-lg-3" style={{ paddingTop: "44px" }}>
                                                <SelectValidator
                                                    value={tipoVeiculo}
                                                    name="tipoVeiculo"
                                                    className="form-ui-bootstrap select-busca-veiculos"
                                                    onChange={this.handleChange}>
                                                    <MenuItem value="todos">Todos</MenuItem>
                                                    <MenuItem value="novos">0 Km</MenuItem>
                                                    <MenuItem value="seminovos">Seminovos</MenuItem>
                                                </SelectValidator>
                                            </div>

                                            <div className="col-lg-3 text-center" style={{ paddingTop: "30px" }}>
                                                <button type="submit" className="btn m-btn">BUSCAR VEÍCULOS<span className="fa fa-angle-right"></span></button><br />
                                                <p className="linkLimparBusca text-center" onClick={this.handleClick} style={{ color: "#362e88" }}>LIMPAR BUSCA</p>
                                            </div>
                                        </div>
                                    </div>
                                </ValidatorForm>

                                <div className="row">
                                    {currentVehicles.map(v => (
                                        <div className="col-lg-4" key={v.id}>
                                            <Link to={`/${v.href_revenda}/${v.id}`} style={{ textDecoration: 'none' }}>
                                                <div className="car-item">
                                                    <div className="car-image">
                                                        <img
                                                            src={
                                                                v.imagens?.length > 0
                                                                    ? v.imagens[0].fileUrl || v.imagens[0].fileThumb
                                                                    : "/images/car_default.png"
                                                            }
                                                            alt={v.vefipe_name}
                                                        />
                                                        <span className={`car-badge ${v.vequilometragem <= 100 ? 'novo' : 'usado'}`}>
                                                            {v.vequilometragem <= 100 ? 'Novo' : 'Seminovo'}
                                                        </span>
                                                        <span className="car-km">
                                                            {Number(v.vequilometragem || 0).toLocaleString('pt-BR')} km
                                                        </span>
                                                    </div>

                                                    <div className="car-body">
                                                        <div className="car-make">{v.vefipe_marca}</div>
                                                        <div className="car-model">{v.vefipe_name}</div>
                                                        <div className="car-specs">
                                                            <span className="car-spec">{v.veano_fabricacao}/{v.vefipe_ano_modelo}</span>
                                                            <span className="car-spec">{formatCambio(v.vecambio)}</span>
                                                        </div>
                                                        <div className="car-footer">
                                                            <div>
                                                                <div className="car-price-label">Apenas por</div>
                                                                <div className="car-price">{formatMoney(v.vevalor)}</div>
                                                            </div>
                                                            <div className="car-arrow">›</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                                <ul className="pagination">
                                    {this.renderPageNumbers()}
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <hr className="gray"></hr>

                <Rodape revenda={this.state.revenda} />
            </div>
        )
    }
}

function formatMoney(value) {
    var places = 2;
    var symbol = "R$ ";
    var thousand = ".";
    var decimal = ",";

    places = !isNaN(places = Math.abs(places)) ? places : 2;
    symbol = symbol !== undefined ? symbol : "$";
    thousand = thousand || ",";
    decimal = decimal || ".";
    var number = value,
        negative = number < 0 ? "-" : "",
        i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "";
    var j = i.length > 3 ? i.length % 3 : 0;
    return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
};

function formatCambio(value) {
    if (value === 'A') {
        return "Automático";
    } else {
        return "Manual";
    }
}

function shuffleArray(items) {
    const result = [...items];

    for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [result[j], result[i]];
    }

    return result;
}

export default Estoque
